<div class="tschedule">

  <div class="remind">
    <div class="mlabel">Schedule Repeating Task</div>
    <!-- <mat-slide-toggle color="primary"></mat-slide-toggle> -->
  </div>


    <mat-form-field>
      <mat-label>Schedule By</mat-label>
      <mat-select value="1" [(ngModel)]="selectedValue">
        <mat-option value="1">Specific Date </mat-option>
        <mat-option value="2">Recurring</mat-option>
        <mat-option value="3">According to another task</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="selectedSchedule bydate" *ngIf="selectedValue == 1">
      <div class="bdivision">
        <label>Schedule task by specific date</label>
        <mat-checkbox checked color="primary">End Date</mat-checkbox>
      </div>

      <div class="specific">

        <mat-form-field class="datefield">
          <mat-label>Start date</mat-label>
          <input matInput [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <div class="field">
        
          <ngx-timepicker-field></ngx-timepicker-field>
        </div>

      </div>

      <div class="specific">

        <mat-form-field class="datefield">
          <mat-label>End date</mat-label>
          <input matInput [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <div class="field">
       
          <ngx-timepicker-field></ngx-timepicker-field>
        </div>

      </div>

    </div>

    <div class="selectedSchedule byrecurring" *ngIf="selectedValue == 2">
      <label>Recurring</label>

      <div class="specific">

        <mat-form-field class="datefield">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="picker2">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

        <div class="fieldr">
          <mat-form-field>
            <mat-label>Repeat every</mat-label>
            <mat-select value="">
              <mat-option value="">1</mat-option>
              <mat-option value="">2</mat-option>
              <mat-option value="">3</mat-option>
              <mat-option value="">4</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldr">
          <mat-form-field>
            <mat-label>Repeat</mat-label>
            <mat-select value="">
              <mat-option value="">day</mat-option>
              <mat-option value="">week</mat-option>
              <mat-option value="">month</mat-option>
              <mat-option value="">year</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>

      <p class="occurs">Repeat On</p>

      <div class="everyday">

        <label class="checkmark">
          <input type="checkbox" checked="checked">
          <span class="">M</span>
        </label>
        <label class="checkmark">
          <input type="checkbox" checked="checked">
          <span class="">T</span>
        </label>
        <label class="checkmark">
          <input type="checkbox" checked="checked">
          <span class="">W</span>
        </label>
        <label class="checkmark">
          <input type="checkbox" checked="checked">
          <span class="">T</span>
        </label>

        <label class="checkmark">
          <input type="checkbox" checked="checked">
          <span class="">F</span>
        </label>
        <label class="checkmark">
          <input type="checkbox" checked="checked">
          <span class="">S</span>
        </label>
        <label class="checkmark">
          <input type="checkbox" checked="checked">
          <span class="">S</span>
        </label>

      </div>

      <p class="occurs">Ends On</p>
      
      <div class="endon">
        <mat-radio-group name="end"  color="primary">
          <mat-radio-button value="1">Never</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="endon">
        <mat-radio-group name="end"  color="primary">
          <mat-radio-button value="1">On</mat-radio-button>
        </mat-radio-group>

        <mat-form-field class="datefield">
          <mat-label>End On</mat-label>
          <input matInput [matDatepicker]="picker3">
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
        </mat-form-field>

      </div>

      <div class="endon">
        <mat-radio-group name="end"  color="primary">
          <mat-radio-button value="1">After</mat-radio-button>
        </mat-radio-group>

        <div class="datefield">
          <mat-form-field>
            <mat-label>Occurence</mat-label>
            <mat-select value="">
              <mat-option value="">1</mat-option>
              <mat-option value="">5</mat-option>
              <mat-option value="">10</mat-option>
              <mat-option value="">15</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

    </div>

    <div class="selectedSchedule byanothertask" *ngIf="selectedValue == 3">
      <label>According to another task</label>

      <div class="specific">



        <div class="fieldr">
          <mat-form-field>
            <mat-label>Due</mat-label>
            <mat-select value="">
              <mat-option value="">1</mat-option>
              <mat-option value="">2</mat-option>
              <mat-option value="">3</mat-option>
              <mat-option value="">4</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldr">
          <mat-form-field>
            <mat-label>Days</mat-label>
            <mat-select value="">
              <mat-option value="">Before</mat-option>
              <mat-option value="">After</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldr">
          <mat-form-field class="">
            <mat-label>Due date</mat-label>
            <input matInput [matDatepicker]="picker3">
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
          </mat-form-field>
        </div>


      </div>
      <div class="fullw">
        <mat-form-field>
          <mat-label>Task under </mat-label>
          <mat-select value="">
            <mat-option value="">Core</mat-option>
            <mat-option value="">Contact</mat-option>
            <mat-option value="">Company</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="fullw">
        <mat-form-field>
          <mat-label>Select task</mat-label>
          <mat-select value="">
            <mat-option value="">See how easy it is to customize Copper </mat-option>
            <mat-option value="">Start to diagnose covid patients</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="fieldr">
        <mat-form-field class="">
          <mat-label>Due time</mat-label>
          <input matInput >
          <mat-datepicker-toggle matSuffix ></mat-datepicker-toggle>
          <mat-datepicker ></mat-datepicker>
        </mat-form-field>
      </div>

    </div>

    <div class="actionBtnHolder">
      <button
        mat-flat-button
        class="cancel"
        (click)="close()"
      >
        Close
      </button>
      <button
        mat-flat-button
        class="calltoaction"
        type="submit"
        color="primary"
      >
        Assign
      </button>
    </div>

  </div>